import React from 'react';
import MapContext from './MapContext';

class GoogleMaps extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {map: null};
        this.mapRef = React.createRef();
    }

    componentDidMount() {
        const map = this.getMap();
        this.setState({map});
    }

    getMap() {
        if (!this.mapRef.current) {
            return null;
        }

        return new google.maps.Map(this.mapRef.current, this.props.options);
    }

    render() {
        const {children} = this.props;
        return (
            <MapContext.Provider value={this.state.map}>
                <div style={{height: 500}} ref={this.mapRef} />
                {children}
            </MapContext.Provider>
        );
    }
}

export default GoogleMaps;
